import { CommonModule, NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { ChatProfileComponent } from '../chat-profile/chat-profile.component';

@Component({
  selector: 'app-chat-rule',
  standalone: true,
  imports: [CommonModule, NgClass, CSButtonComponent],
  templateUrl: './chat-rule.component.html',
  styleUrls: ['./chat-rule.component.scss'],
})
export class ChatRuleComponent {
  ruleList = [
    {
      title: 'Respect Others',
      content: [
        'No insults, harassment, threats, or discriminatory language.',
        'Treat all players and staff with courtesy.',
      ],
    },
    {
      title: 'No Spam or Flooding',
      content: [
        'Do not send repeated or meaningless messages.',
        'Avoid excessive use of emojis, capital letters, or symbols.',
      ],
    },
    {
      title: 'Stay On-Topic',
      content: [
        'Chat is for socializing about games and general conversation.',
        'Do not use the chat to advertise or promote external services.',
      ],
    },
    {
      title: 'No Offensive Content',
      content: [
        'Strictly no hate speech, racist/sexist remarks, or offensive jokes.',
        'Do not share explicit, violent, or inappropriate material.',
      ],
    },
    {
      title: 'No Offensive or Inappropriate Usernames',
      content: [
        'Usernames must not include offensive, discriminatory, or obscene words.',
        'Impersonating staff or other players is strictly prohibited.',
      ],
    },
    {
      title: 'No Collusion or Game Influence',
      content: [
        'Players must not share strategies, hand details, or discuss ongoing bets that could influence play.',
        'Do not encourage or coordinate unfair play.',
      ],
    },
    {
      title: 'No Self-Promotion or Solicitation',
      content: [
        'Do not post links, referral codes, or promote other websites/apps.',
        'Personal contact information (phone, email, social media) is not allowed.',
      ],
    },
    {
      title: 'English (or Designated Language) Only',
      content: [
        'To ensure fair moderation, all messages must be in the official language(s) supported by the platform.',
      ],
    },
    {
      title: 'No Complaints or Support Requests in Chat',
      content: ['Customer support issues must be directed to official support channels, not public chat.'],
    },
    {
      title: 'No Underage References',
      content: [
        'Do not make jokes or references about underage gambling.',
        'Only adults (as defined by local laws) are permitted to participate.',
      ],
    },
    {
      title: 'Moderator Authority',
      content: [
        'Follow instructions from moderators or administrators.',
        'Violations may result in warnings, mute, suspension, or permanent ban.',
      ],
    },
  ];
  constructor(private dialogRef: MatDialogRef<ChatProfileComponent>) {}

  handleCloseChatRule() {
    this.dialogRef.close();
  }
}
